export const runtimeEnvironment = {
  BUILD_NUMBER: '18842778-9875-4fec-85f8-15d9eccb4669',
  SENTRY_ENABLED: true,
};
